import { createContext } from 'react';

export const LoyaltyContext = createContext();
